import {
  type ExtractDocumentTypeFromTypedRxJsonSchema,
  type RxCollection,
  type RxJsonSchema,
  toTypedRxJsonSchema,
} from "rxdb";
import { useRxCollection, type useRxData } from "rxdb-hooks";
import { SYNCABLE_META } from "./common";

export const RXDB_IMAGING_STUDY_COLLECTION_NAME = "imaging-study";

export const useRxCollectionImagingStudy =
  (): RxCollection<ImagingStudy> | null =>
    useRxCollection<ImagingStudy>(RXDB_IMAGING_STUDY_COLLECTION_NAME);

type UseRxData = Parameters<typeof useRxData<ImagingStudy>>;
export type ImagingStudyQueryConstructor = UseRxData["1"];

const IMAGING_STUDY_SCHEMA_LITERAL = {
  title: "imaging study schema",
  version: 4,
  description: "Represents an imaging study",
  type: "object",
  primaryKey: "id",
  properties: {
    id: {
      type: "string",
      maxLength: 100,
    },
    elephantPatientId: {
      type: "string",
    },
    accessionNumber: {
      type: "string",
    },
    meta: SYNCABLE_META,
  },
  required: ["id", "elephantPatientId", "accessionNumber", "meta"],

  /*
   * It is important to set 'as const' to preserve the literal type.
   *
   * biome-ignore lint/suspicious/noExplicitAny: We infer the DB type from this
   * object, the satisfies just provides us type inference for this object.
   */
} as const satisfies RxJsonSchema<any>;

const schemaTyped = toTypedRxJsonSchema(IMAGING_STUDY_SCHEMA_LITERAL);

export type ImagingStudy = ExtractDocumentTypeFromTypedRxJsonSchema<
  typeof schemaTyped
>;

export const IMAGING_STUDY_SCHEMA: RxJsonSchema<ImagingStudy> =
  IMAGING_STUDY_SCHEMA_LITERAL;
